
import { BaseAPI } from "../../BaseAPI";
import * as environment from '../../../config/environment';

class KullaniciSifreDegistirAPI extends BaseAPI {
  

  constructor () {
    const baseUrl = environment.API_URL + "KullaniciSifreDegistir";
    super(baseUrl);
  }


  saveKullaniciSifreDegistirSave(request: KullaniciSifreDegistirRequest){
    
    return this.post("", request, true);
   
  }

}
export default new KullaniciSifreDegistirAPI();
class KullaniciSifreDegistirRequest {
    kullaniciKodu?: string;
    vergiNo?: string;
    sifre: string;
   

    constructor(sifre: string, kullaniciKodu?: string, vergiNo?: string) {
        this.sifre = sifre;
        this.kullaniciKodu = kullaniciKodu;
        this.vergiNo = vergiNo;

    }
}
export { KullaniciSifreDegistirRequest };